<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <label>
        <input
          v-if="mostrarSeletor"
          data-test-id="input-guiatoggle-1"
          style="margin-right: 8px"
          type="checkbox"
          @click="guiaToggle($event, guia)"
        />
        <strong>{{ guia.autorizacao.numeroGuia }}</strong>
      </label>
      <div v-if="mostrarDeletar" class="pull-right">
        <Longpress
          :value="guia"
          :on-confirm="removerGuia"
          class="btn btn-default btn-xs"
          duration="1"
          pressing-text="Removendo {$rcounter}"
          action-text="Removido"
        >
          Remover
        </Longpress>
      </div>
    </div>
    <table class="table table-striped table-hover">
      <tbody>
        <tr>
          <td><strong>Paciente</strong></td>
          <td>{{ guia.beneficiario.nome }}</td>
        </tr>
        <tr>
          <td><strong>Convênio</strong></td>
          <td>{{ guia.beneficiario.plano }}</td>
        </tr>
        <tr>
          <td><strong>Data emissão</strong></td>
          <td>{{
            formatarData(guia.autorizacao.dataEmissao, 'DD/MM/YYYY')
          }}</td>
        </tr>
        <tr v-if="mostrarSeletorAgendamentos">
          <td><strong>Agendamentos</strong></td>
          <td>
            {{ agendamentosSelecionados.length }} / {{ agendamentos.length }}
            <Dropdown
              ref="dropdown"
              v-model="mostrarAgendamentos"
              class="dropdown-form pull-right"
            >
              <button
                data-test-id="button-auto-2"
                type="button"
                class="btn btn-link btn-xs dropdown-toggle"
              >
                Especificar
                <span class="caret" />
              </button>
              <template #dropdown>
                <table
                  class="table table-striped table-hover table-condensed table-bordered"
                >
                  <thead>
                    <tr>
                      <th>
                        <input
                          ref="todosAgendamentosCheckbox"
                          data-test-id="input-toggletodosagendamentos-3"
                          type="checkbox"
                          @click="toggleTodosAgendamentos"
                        />
                      </th>
                      <th>Data</th>
                      <th>Hora</th>
                      <th>Especialidade</th>
                      <th>Profissional</th>
                      <th>Status</th>
                      <th>Faturamento</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="agendamento in agendamentos"
                      :key="agendamento._id"
                    >
                      <td>
                        <input
                          v-model="agendamentosSelecionados"
                          data-test-id="input-agendamentosselecionados"
                          :value="agendamento._id"
                          :disabled="agendamento.faturamento"
                          type="checkbox"
                          @click="toggleAgendamento"
                        />
                      </td>
                      <td>{{
                        formatarData(agendamento.data, 'DD/MM/YYYY')
                      }}</td>
                      <td>{{ agendamento.hora }}</td>
                      <td>{{ agendamento.especialidade }}</td>
                      <td>{{ agendamento.profissional.nome }}</td>
                      <td
                        :class="
                          'status_agendamento agendamento-legenda-item--' +
                          agendamento.status
                        "
                        >{{ caixaAlta(agendamento.status) }}</td
                      >
                      <td>{{
                        agendamento.faturamento ? agendamento.faturamento : '-'
                      }}</td>
                    </tr>
                  </tbody>
                </table>
              </template>
            </Dropdown>
          </td>
        </tr>
        <tr v-else>
          <td><strong>Agendamentos</strong></td>
          <td>{{ guia.agendamentos.length }}</td>
        </tr>
        <tr>
          <td><strong>Procedimentos</strong></td>
          <td>
            <button
              type="button"
              style="display: contents"
              class="btn btn-link btn-xs"
              @click="
                exibirAlertaValores(
                  'Procedimentos',
                  guia.solicitacao.procedimentos,
                  ['codigoTabela', 'codigo', 'nome'],
                  ['Tabela', 'Código', 'Nome']
                )
              "
            >
              Ver todos
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Longpress from 'vue-longpress'

import { alertaMixin } from '@/mixins/AlertaMixin'
import GuiaServico from '@/servicos/GuiaServico'
import * as formatadores from '@/utils/formatadores'

const guiaServico = new GuiaServico()

export default {
  name: 'GuiaFaturamentoFicha',
  components: { Longpress },
  mixins: [alertaMixin],
  props: {
    guia: {
      type: Object,
      required: true,
    },
    mostrarSeletor: {
      type: Boolean,
      default: true,
    },
    mostrarDeletar: {
      type: Boolean,
      default: false,
    },
    mostrarSeletorAgendamentos: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mostrarAgendamentos: false,
      agendamentos: [],
      agendamentosSelecionados: [],
    }
  },
  mounted() {
    this.recuperarAgendamentos()
  },
  methods: {
    ...formatadores,
    toggleAgendamento(event) {
      const selecionados =
        this.agendamentosSelecionados.length + (event.target.checked ? 1 : -1)
      const disponiveis = this.agendamentos.length
      const guia = this.guia
      const agendamentos = this.agendamentosSelecionados

      if (event.target.checked) {
        agendamentos.push(event.target.value)
      } else {
        const index = agendamentos.indexOf(event.target.value)
        agendamentos.splice(index, 1)
      }

      if (selecionados === disponiveis) {
        this.$refs.todosAgendamentosCheckbox.checked = true
      } else if (selecionados === 0) {
        this.$refs.todosAgendamentosCheckbox.checked = false
      } else {
        this.$refs.todosAgendamentosCheckbox.indeterminate = true
      }

      this.$emit('selecionarAgendamentos', { guia, agendamentos })
    },
    toggleTodosAgendamentos(event) {
      if (event.target.checked) {
        this.agendamentosSelecionados.push(
          ...this.agendamentos.filter((a) => !a.faturamento).map((a) => a._id)
        )
      } else {
        this.agendamentosSelecionados = []
      }

      this.$emit('selecionarAgendamentos', {
        guia: this.guia,
        agendamentos: this.agendamentosSelecionados,
      })
    },
    recuperarAgendamentos() {
      if (!this.agendamentos.length) {
        const filtro = {
          guiaId: this.guia._id,
          limit: 20,
          skip: 0,
        }

        guiaServico.recuperarAgendamentosTotal(filtro).then((res) => {
          if (res.total) {
            guiaServico.recuperarAgendamentos(filtro).then((res) => {
              this.agendamentos = res.agendamentos
              this.agendamentosSelecionados = this.agendamentos
                .filter((a) => !a.faturamento)
                .map((a) => a._id)
              const comFaturamento = this.agendamentos
                .filter((a) => a.faturamento)
                .map((a) => a._id)
              const daGuia = this.guia.agendamentos

              if (daGuia.length !== this.agendamentosSelecionados.length) {
                const daGuiaMenosFaturamento = [
                  ...comFaturamento.filter((x) => daGuia.indexOf(x) === -1),
                  ...daGuia.filter((x) => comFaturamento.indexOf(x) === -1),
                ]

                this.agendamentosSelecionados = daGuiaMenosFaturamento

                if (this.agendamentosSelecionados.length) {
                  this.$refs.todosAgendamentosCheckbox.indeterminate = true
                } else {
                  this.$refs.todosAgendamentosCheckbox.checked = false
                }
              } else {
                this.$refs.todosAgendamentosCheckbox.checked = true
              }
            })
          }
        })
      }
    },
    removerGuia(guia) {
      this.$emit('removerGuia', guia)
    },
    guiaToggle(e, guia) {
      const toggle = e.target.checked
      this.$emit('guiaToggle', { toggle, guia })
    },
  },
}
</script>

<style>
.dropdown-form .dropdown-menu {
  min-width: 400px;
  padding: 10px;
}
</style>
